import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'

import FansiMark from '@/atoms/FansiMark'
import FansiKind from '@/ts/enums/global/FansiKind'
import Product from '@/ts/Product'

function Header(props: HeaderProps) {
  const { t } = useTranslation('global')
  const { product } = props

  const kind: FansiKind = FansiKind.FansiExperience

  return (
    <div>
      <h1 className="mb-4 text-2xl font-medium break-words">{product.name}</h1>
      <div className="flex items-center space-x-4 mb-6">
        <span className="text-black/60">{t(kind)}</span>
        <FansiMark kind={kind} />
      </div>
    </div>
  )
}

interface HeaderProps {
  product: Product
}

export default memo(Header)
